// Collapse-Funktionalität für Feature-Boxen
// Toggled die .collapse-Elemente via data-toggle="collapse"

export function initCollapseFeatures(): void {
    const collapseLinks = document.querySelectorAll('[data-toggle="collapse"]');

    collapseLinks.forEach((link) => {
        // Initiale ARIA-Attribute setzen
        const href = link.getAttribute('href');
        if (href) {
            link.setAttribute('aria-controls', href.substring(1));
            link.setAttribute('aria-expanded', 'false');
        }

        link.addEventListener('click', (e) => {
            e.preventDefault();

            const currentHref = link.getAttribute('href');
            if (!currentHref) return;

            const targetId = currentHref.substring(1);
            const target = document.getElementById(targetId);

            if (!target) return;

            const isOpen = target.classList.toggle('open');

            // Alle Links, die dasselbe Element steuern, synchronisieren
            collapseLinks.forEach(l => {
                if (l.getAttribute('href') === `#${targetId}`) {
                    l.setAttribute('aria-expanded', String(isOpen));
                }
            });
        });
    });
}
